export { default } from "./getParsedURL";
